import React, { useState, useEffect } from "react";
import Pagination from '../../../../components/pagination/Pagination.jsx';
import columns from "../../../../columns/ib/MT5Account/MT5RejectAccount.js";
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton.jsx';
import { GetAllAccountApi } from '../../../../api/request/liveAccount.js';
import moment from "moment";
import { useSelector } from "react-redux";

export default function Accounts({ dates }) {

  const [isLoading, setIsLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [data, setData] = useState([]);

  const getDeclinedAccounts = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        SearchText: dates,
        FilterText: "Rejected",
        Sortby:'actionDate'
      }
      setIsLoading(true);
      const { data } = await GetAllAccountApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: `${item?.firstName} ${item?.lastName}`,
              balance:`$ ${item?.balance}`,
              createdDate: (item?.createdDate ? moment(item?.createdDate).format("DD-MM-YYYY, hh:mm A") : null),
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getDeclinedAccounts();
  }, [page, pageSize, dates, filter]);
 
  return (
    <div>
      <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
        <div className="px-4 lg:px-6"><p className="text-[#2F2B3D] text-xl font-semibold">Declined Accounts</p></div>
        <div className="my-6">
          <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
          <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
        </div>
      </div>
    </div>
  )
}